<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'sway',
    },
    delay: {
      type: Number,
      required: false,
      default: 0,
    },
    pause: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tween: undefined,
    };
  },
  computed: {
    options() {
      return {
        delay: this.delay,
      };
    },
  },
  mounted() {
    this.animate();
  },
  watch: {
    pause() {
      if (this.pause) {
        this.tween.pause();
      } else {
        this.tween.play();
      }
    },
  },
  methods: {
    animate() {
      if (this.type === 'sway') {
        this.sway();
      }
      if (this.type === 'float') {
        this.float();
      }
      if (this.type === 'swing') {
        this.swing();
      }
    },
    sway() {
      this.tween = gsap.to(this.$el, {
        ...this.options,
        x: "10%",
        duration: 1,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    },
    float() {
      this.tween = gsap.to(this.$el, {
        ...this.options,
        y: "8%",
        // rotation: 5,
        duration: 1,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    },
    swing() {
      this.tween = gsap.to(this.$el, {
        ...this.options,
        rotation: 10,
        transformOrigin: "center bottom",
        duration: 1,
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.container {

}
</style>